export const ContemberClientNames = {
    "entities": {
        "AllowedUser": {
            "name": "AllowedUser",
            "fields": {
                "id": {
                    "type": "column"
                },
                "email": {
                    "type": "column"
                },
                "personId": {
                    "type": "column"
                },
                "isAllowed": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "email",
                "personId",
                "isAllowed"
            ]
        },
        "CloudProject": {
            "name": "CloudProject",
            "fields": {
                "id": {
                    "type": "column"
                },
                "project": {
                    "type": "many",
                    "entity": "Project"
                },
                "projectSlug": {
                    "type": "column"
                },
                "projectGroupSlug": {
                    "type": "column"
                },
                "githubInstalledAt": {
                    "type": "column"
                },
                "apiUrl": {
                    "type": "column"
                },
                "adminUrl": {
                    "type": "column"
                },
                "selfCareUrl": {
                    "type": "column"
                },
                "deployToken": {
                    "type": "column"
                },
                "deployTokenCreatedAt": {
                    "type": "column"
                },
                "adminToken": {
                    "type": "column"
                },
                "adminTokenCreatedAt": {
                    "type": "column"
                },
                "loginToken": {
                    "type": "column"
                },
                "loginTokenCreatedAt": {
                    "type": "column"
                },
                "tokensEncrypted": {
                    "type": "column"
                },
                "lastDeployment": {
                    "type": "one",
                    "entity": "CloudProjectDeployment"
                },
                "deployments": {
                    "type": "many",
                    "entity": "CloudProjectDeployment"
                }
            },
            "scalars": [
                "id",
                "projectSlug",
                "projectGroupSlug",
                "githubInstalledAt",
                "apiUrl",
                "adminUrl",
                "selfCareUrl",
                "deployToken",
                "deployTokenCreatedAt",
                "adminToken",
                "adminTokenCreatedAt",
                "loginToken",
                "loginTokenCreatedAt",
                "tokensEncrypted"
            ]
        },
        "CloudProjectDeployment": {
            "name": "CloudProjectDeployment",
            "fields": {
                "id": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "CloudProject"
                },
                "deployedAt": {
                    "type": "column"
                },
                "deployedBy": {
                    "type": "one",
                    "entity": "Person"
                }
            },
            "scalars": [
                "id",
                "deployedAt"
            ]
        },
        "Config": {
            "name": "Config",
            "fields": {
                "id": {
                    "type": "column"
                },
                "key": {
                    "type": "column"
                },
                "value": {
                    "type": "column"
                },
                "valueBool": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "key",
                "value",
                "valueBool"
            ]
        },
        "GitHubRepository": {
            "name": "GitHubRepository",
            "fields": {
                "id": {
                    "type": "column"
                },
                "organizationId": {
                    "type": "column"
                },
                "repositoryId": {
                    "type": "column"
                },
                "repoOwner": {
                    "type": "column"
                },
                "repoName": {
                    "type": "column"
                },
                "repoMainBranch": {
                    "type": "column"
                },
                "createdBy": {
                    "type": "one",
                    "entity": "Person"
                },
                "createdAt": {
                    "type": "column"
                },
                "deployTokenAttached": {
                    "type": "one",
                    "entity": "CloudProject"
                },
                "deployTokenAttachedAt": {
                    "type": "column"
                },
                "archivedBy": {
                    "type": "one",
                    "entity": "Person"
                },
                "archivedAt": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "organizationId",
                "repositoryId",
                "repoOwner",
                "repoName",
                "repoMainBranch",
                "createdAt",
                "deployTokenAttachedAt",
                "archivedAt"
            ]
        },
        "Person": {
            "name": "Person",
            "fields": {
                "id": {
                    "type": "column"
                },
                "personId": {
                    "type": "column"
                },
                "cloudAccessToken": {
                    "type": "column"
                },
                "cloudAccessTokenExpiration": {
                    "type": "column"
                },
                "cloudRefreshToken": {
                    "type": "column"
                },
                "cloudRefreshTokenExpiration": {
                    "type": "column"
                },
                "projects": {
                    "type": "many",
                    "entity": "Project"
                },
                "sendDeployedEmail": {
                    "type": "column"
                },
                "tenantPerson": {
                    "type": "one",
                    "entity": "TenantPerson"
                }
            },
            "scalars": [
                "id",
                "personId",
                "cloudAccessToken",
                "cloudAccessTokenExpiration",
                "cloudRefreshToken",
                "cloudRefreshTokenExpiration",
                "sendDeployedEmail"
            ]
        },
        "PersonSigningCode": {
            "name": "PersonSigningCode",
            "fields": {
                "id": {
                    "type": "column"
                },
                "status": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "expiresAt": {
                    "type": "column"
                },
                "verifiedAt": {
                    "type": "column"
                },
                "person": {
                    "type": "one",
                    "entity": "Person"
                }
            },
            "scalars": [
                "id",
                "status",
                "createdAt",
                "expiresAt",
                "verifiedAt"
            ]
        },
        "Plugin": {
            "name": "Plugin",
            "fields": {
                "id": {
                    "type": "column"
                },
                "organizationId": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "slug": {
                    "type": "column"
                },
                "description": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "archivedAt": {
                    "type": "column"
                },
                "activeRelease": {
                    "type": "one",
                    "entity": "PluginRelease"
                },
                "releases": {
                    "type": "many",
                    "entity": "PluginRelease"
                }
            },
            "scalars": [
                "id",
                "organizationId",
                "name",
                "slug",
                "description",
                "createdAt",
                "archivedAt"
            ]
        },
        "PluginRelease": {
            "name": "PluginRelease",
            "fields": {
                "id": {
                    "type": "column"
                },
                "type": {
                    "type": "column"
                },
                "description": {
                    "type": "column"
                },
                "schema": {
                    "type": "column"
                },
                "dependencies": {
                    "type": "column"
                },
                "handler": {
                    "type": "column"
                },
                "handlerArgs": {
                    "type": "column"
                },
                "plugin": {
                    "type": "one",
                    "entity": "Plugin"
                },
                "activeFor": {
                    "type": "one",
                    "entity": "Plugin"
                },
                "createdAt": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "type",
                "description",
                "schema",
                "dependencies",
                "handler",
                "handlerArgs",
                "createdAt"
            ]
        },
        "Project": {
            "name": "Project",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdBy": {
                    "type": "one",
                    "entity": "Person"
                },
                "createdAt": {
                    "type": "column"
                },
                "organizationId": {
                    "type": "column"
                },
                "archivedAt": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "type": {
                    "type": "column"
                },
                "intent": {
                    "type": "column"
                },
                "status": {
                    "type": "column"
                },
                "internalType": {
                    "type": "column"
                },
                "notificationEmailSent": {
                    "type": "column"
                },
                "offerAiRefreshFor": {
                    "type": "column"
                },
                "generatedSteps": {
                    "type": "column"
                },
                "isLocked": {
                    "type": "column"
                },
                "isDownloadable": {
                    "type": "column"
                },
                "lockedAt": {
                    "type": "column"
                },
                "version": {
                    "type": "column"
                },
                "specification": {
                    "type": "one",
                    "entity": "Specification"
                },
                "structure": {
                    "type": "one",
                    "entity": "Structure"
                },
                "schema": {
                    "type": "one",
                    "entity": "ProjectSchema"
                },
                "repository": {
                    "type": "one",
                    "entity": "GitHubRepository"
                },
                "workflows": {
                    "type": "one",
                    "entity": "Workflows"
                },
                "delivery": {
                    "type": "one",
                    "entity": "ProjectDelivery"
                },
                "cloudProject": {
                    "type": "one",
                    "entity": "CloudProject"
                },
                "logs": {
                    "type": "many",
                    "entity": "ProjectLog"
                },
                "tags": {
                    "type": "many",
                    "entity": "Tag"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "organizationId",
                "archivedAt",
                "name",
                "type",
                "intent",
                "status",
                "internalType",
                "notificationEmailSent",
                "offerAiRefreshFor",
                "generatedSteps",
                "isLocked",
                "isDownloadable",
                "lockedAt",
                "version"
            ]
        },
        "ProjectDelivery": {
            "name": "ProjectDelivery",
            "fields": {
                "id": {
                    "type": "column"
                },
                "frontendDeveloper": {
                    "type": "column"
                },
                "deliveryTime": {
                    "type": "column"
                },
                "budget": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                }
            },
            "scalars": [
                "id",
                "frontendDeveloper",
                "deliveryTime",
                "budget"
            ]
        },
        "ProjectEditFileChange": {
            "name": "ProjectEditFileChange",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdBy": {
                    "type": "one",
                    "entity": "Person"
                },
                "createdAt": {
                    "type": "column"
                },
                "filePath": {
                    "type": "column"
                },
                "fileOperation": {
                    "type": "column"
                },
                "fileContent": {
                    "type": "column"
                },
                "session": {
                    "type": "one",
                    "entity": "ProjectEditSession"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "filePath",
                "fileOperation",
                "fileContent"
            ]
        },
        "ProjectEditSession": {
            "name": "ProjectEditSession",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdBy": {
                    "type": "one",
                    "entity": "Person"
                },
                "createdAt": {
                    "type": "column"
                },
                "organizationId": {
                    "type": "column"
                },
                "archivedAt": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                },
                "sourceCodeZip": {
                    "type": "column"
                },
                "sourceCodeGitHubBranch": {
                    "type": "column"
                },
                "sourceCodePreviousSession": {
                    "type": "one",
                    "entity": "ProjectEditSession"
                },
                "sandboxId": {
                    "type": "column"
                },
                "sandboxCreatedAt": {
                    "type": "column"
                },
                "sandboxExpiresAt": {
                    "type": "column"
                },
                "sandboxUrl": {
                    "type": "column"
                },
                "sandboxProvider": {
                    "type": "column"
                },
                "tags": {
                    "type": "many",
                    "entity": "Tag"
                },
                "changes": {
                    "type": "many",
                    "entity": "ProjectEditFileChange"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "organizationId",
                "archivedAt",
                "sourceCodeZip",
                "sourceCodeGitHubBranch",
                "sandboxId",
                "sandboxCreatedAt",
                "sandboxExpiresAt",
                "sandboxUrl",
                "sandboxProvider"
            ]
        },
        "ProjectEditorCodebase": {
            "name": "ProjectEditorCodebase",
            "fields": {
                "id": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                },
                "session": {
                    "type": "one",
                    "entity": "ProjectEditSession"
                },
                "path": {
                    "type": "column"
                },
                "hash": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "adjustedAt": {
                    "type": "column"
                },
                "archivedAt": {
                    "type": "column"
                },
                "snippets": {
                    "type": "many",
                    "entity": "ProjectEditorCodebaseSnippet"
                }
            },
            "scalars": [
                "id",
                "path",
                "hash",
                "createdAt",
                "adjustedAt",
                "archivedAt"
            ]
        },
        "ProjectEditorCodebaseSnippet": {
            "name": "ProjectEditorCodebaseSnippet",
            "fields": {
                "id": {
                    "type": "column"
                },
                "codebase": {
                    "type": "one",
                    "entity": "ProjectEditorCodebase"
                },
                "summary": {
                    "type": "column"
                },
                "summaryTokens": {
                    "type": "column"
                },
                "summaryEmbeddingId": {
                    "type": "column"
                },
                "code": {
                    "type": "column"
                },
                "codeEmbeddingId": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "archivedAt": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "summary",
                "summaryTokens",
                "summaryEmbeddingId",
                "code",
                "codeEmbeddingId",
                "createdAt",
                "archivedAt"
            ]
        },
        "ProjectEditorRecipe": {
            "name": "ProjectEditorRecipe",
            "fields": {
                "id": {
                    "type": "column"
                },
                "organizationId": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "slug": {
                    "type": "column"
                },
                "description": {
                    "type": "column"
                },
                "descriptionEmbeddingId": {
                    "type": "column"
                },
                "createdBy": {
                    "type": "one",
                    "entity": "Person"
                },
                "createdAt": {
                    "type": "column"
                },
                "archivedAt": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "organizationId",
                "name",
                "slug",
                "description",
                "descriptionEmbeddingId",
                "createdAt",
                "archivedAt"
            ]
        },
        "ProjectLog": {
            "name": "ProjectLog",
            "fields": {
                "id": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                },
                "createdAt": {
                    "type": "column"
                },
                "prompt": {
                    "type": "column"
                },
                "model": {
                    "type": "column"
                },
                "temperature": {
                    "type": "column"
                },
                "topP": {
                    "type": "column"
                },
                "maxTokens": {
                    "type": "column"
                },
                "response": {
                    "type": "column"
                },
                "finishReason": {
                    "type": "column"
                },
                "promptTokens": {
                    "type": "column"
                },
                "completionTokens": {
                    "type": "column"
                },
                "totalTokens": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "prompt",
                "model",
                "temperature",
                "topP",
                "maxTokens",
                "response",
                "finishReason",
                "promptTokens",
                "completionTokens",
                "totalTokens"
            ]
        },
        "ProjectSchema": {
            "name": "ProjectSchema",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "updatedAt": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                },
                "schema": {
                    "type": "column"
                },
                "dsl": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "updatedAt",
                "schema",
                "dsl"
            ]
        },
        "Prompt": {
            "name": "Prompt",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "owners": {
                    "type": "many",
                    "entity": "PromptOwner"
                },
                "activeRevision": {
                    "type": "one",
                    "entity": "PromptRevision"
                },
                "revisions": {
                    "type": "many",
                    "entity": "PromptRevision"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "name"
            ]
        },
        "PromptGlobalVariables": {
            "name": "PromptGlobalVariables",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "order": {
                    "type": "column"
                },
                "key": {
                    "type": "column"
                },
                "description": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "order",
                "key",
                "description"
            ]
        },
        "PromptMessage": {
            "name": "PromptMessage",
            "fields": {
                "id": {
                    "type": "column"
                },
                "order": {
                    "type": "column"
                },
                "role": {
                    "type": "column"
                },
                "content": {
                    "type": "column"
                },
                "promptRevision": {
                    "type": "one",
                    "entity": "PromptRevision"
                }
            },
            "scalars": [
                "id",
                "order",
                "role",
                "content"
            ]
        },
        "PromptOwner": {
            "name": "PromptOwner",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "order": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "prompts": {
                    "type": "many",
                    "entity": "Prompt"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "order",
                "name"
            ]
        },
        "PromptRevision": {
            "name": "PromptRevision",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "temperature": {
                    "type": "column"
                },
                "engine": {
                    "type": "column"
                },
                "messages": {
                    "type": "many",
                    "entity": "PromptMessage"
                },
                "prompt": {
                    "type": "one",
                    "entity": "Prompt"
                },
                "active": {
                    "type": "one",
                    "entity": "Prompt"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "name",
                "temperature",
                "engine"
            ]
        },
        "Specification": {
            "name": "Specification",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "updatedAt": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                },
                "content": {
                    "type": "column"
                },
                "chapters": {
                    "type": "many",
                    "entity": "SpecificationChapter"
                },
                "specificationChatHistory": {
                    "type": "column"
                },
                "schemaChatHistory": {
                    "type": "column"
                },
                "schemaEditedByUser": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "updatedAt",
                "content",
                "specificationChatHistory",
                "schemaChatHistory",
                "schemaEditedByUser"
            ]
        },
        "SpecificationChapter": {
            "name": "SpecificationChapter",
            "fields": {
                "id": {
                    "type": "column"
                },
                "type": {
                    "type": "column"
                },
                "content": {
                    "type": "column"
                },
                "specification": {
                    "type": "one",
                    "entity": "Specification"
                }
            },
            "scalars": [
                "id",
                "type",
                "content"
            ]
        },
        "Structure": {
            "name": "Structure",
            "fields": {
                "id": {
                    "type": "column"
                },
                "createdAt": {
                    "type": "column"
                },
                "updatedAt": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                },
                "crudDsl": {
                    "type": "column"
                },
                "dsl": {
                    "type": "column"
                }
            },
            "scalars": [
                "id",
                "createdAt",
                "updatedAt",
                "crudDsl",
                "dsl"
            ]
        },
        "Tag": {
            "name": "Tag",
            "fields": {
                "id": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "projects": {
                    "type": "many",
                    "entity": "Project"
                },
                "edits": {
                    "type": "many",
                    "entity": "ProjectEditSession"
                }
            },
            "scalars": [
                "id",
                "name"
            ]
        },
        "TenantPerson": {
            "name": "TenantPerson",
            "fields": {
                "id": {
                    "type": "column"
                },
                "identityId": {
                    "type": "column"
                },
                "email": {
                    "type": "column"
                },
                "name": {
                    "type": "column"
                },
                "otpUri": {
                    "type": "column"
                },
                "otpActivatedAt": {
                    "type": "column"
                },
                "idpOnly": {
                    "type": "column"
                },
                "roles": {
                    "type": "column"
                },
                "person": {
                    "type": "one",
                    "entity": "Person"
                }
            },
            "scalars": [
                "id",
                "identityId",
                "email",
                "name",
                "otpUri",
                "otpActivatedAt",
                "idpOnly",
                "roles"
            ]
        },
        "Workflows": {
            "name": "Workflows",
            "fields": {
                "id": {
                    "type": "column"
                },
                "content": {
                    "type": "column"
                },
                "project": {
                    "type": "one",
                    "entity": "Project"
                }
            },
            "scalars": [
                "id",
                "content"
            ]
        }
    },
    "enums": {
        "ChapterTypes": [
            "intent",
            "requirements",
            "roles",
            "rolesSuggestion",
            "rolesCheck",
            "userFlows",
            "userFlowsCheck",
            "contentBlocksSuggestion",
            "contentBlocks",
            "keyParts",
            "screens",
            "scope",
            "schema",
            "schemaOrigin",
            "preSchema",
            "schemaDsl",
            "schemaDslOrigin"
        ],
        "DeliveryTimes": [
            "immediately",
            "sameDay",
            "nextBusinessDay",
            "inAWeek"
        ],
        "PluginModelRelationType": [
            "many_has_one",
            "one_has_many"
        ],
        "PluginType": [
            "field_attached",
            "basic"
        ],
        "ProjectInternalType": [
            "undefined",
            "test",
            "real"
        ],
        "ProjectStatus": [
            "in_progress",
            "review",
            "done",
            "fixed"
        ],
        "SandboxProvider": [
            "e2b"
        ],
        "fileOperation": [
            "write",
            "delete"
        ],
        "PersonSigningCodeStatus": [
            "waiting",
            "verified",
            "used",
            "revoked"
        ],
        "PromptMessageRole": [
            "system",
            "assistant",
            "user"
        ],
        "PromptRevisionEngine": [
            "gpt35turbo",
            "gpt4"
        ]
    }
};
//# sourceMappingURL=names.js.map